const commentsData = [
    {
        profile: "https://images.pexels.com/users/avatars/6927134/onlyfans-free-account-usernames-and-passwords-627.jpeg?auto=compress&fit=crop&h=60&w=60", 
        name:"Elsemargriet", 
        comments:"Wow, this is a truly amazing capture!"
    },
    {
        profile: "https://images.pexels.com/users/avatars/1442754/bishop-j-n-hall-jr-379.png?auto=compress&fit=crop&h=60&w=60", 
        name:"MarjonBesteman", 
        comments:"Absolut verdient. Ein tolles Foto mit einer fantastischen Message."
    },
    {
        profile: "https://images.pexels.com/users/avatars/399442/valentina-hausermann-759.jpeg?auto=compress&fit=crop&h=60&w=60", 
        name:"TheDigitalArtist", 
        comments:"Fantastisch!! Dynamik pur! Geniale Aufnahme."
    },
    {
        profile: "https://images.pexels.com/users/avatars/3618301/weslley-ribeiro-358.jpeg?auto=compress&fit=crop&h=60&w=60", 
        name:"Elstef", 
        comments:"Great catch!"
    }
]

export default commentsData